// import { Box } from '@mui/material'
import { Orbit } from '@uiball/loaders'
import React from 'react'

import { styles } from './loader.styles'

const Loader = () => {
  return (
    <div style={styles}>
      <Orbit size={80} speed={0.9} color="#A31AFF" />
    </div>
  )
}

export default Loader
